export const collapseEventBuilder = (
	key,
	row,
	setCollapse,
	collapseWhen,
	accordion
) => (e) => {
	e.preventDefault();
	e.stopPropagation();
	(collapseWhen ? collapseWhen(row) : true) &&
		setCollapse((prev) => {
			return prev.includes(key)
				? prev.filter((v) => v !== key)
				: accordion
				? [key]
				: [...prev, key];
		});
};

export const sortEventBuilder = (
	dataIndex,
	sort,
	setState,
	sortDirection = ['asc', 'desc']
) => () => {
	const sorted = sort.orderBy === dataIndex;
	const order = sorted
		? sort.order === sortDirection[0] && sortDirection[1]
			? sortDirection[1]
			: null
		: sortDirection[0];
	setState((prev) => ({
		...prev,
		sort: { orderBy: order && dataIndex, order },
	}));
};

export const dataSorter = (data, sort, columns) => {
	const isDesc = sort.order === 'desc';
	const reverse = isDesc ? -1 : 1;
	const { dataIndex, sortable } = columnFinder(columns, sort.orderBy);
	const isFunc = is.fnc(sortable);
	return [...data].sort((a, b) => {
		const result = isFunc
			? sortable(a[dataIndex], b[dataIndex])
			: /^\d+$/.test(a[dataIndex])
			? parseFloat(a[dataIndex]) - parseFloat(b[dataIndex])
			: a[dataIndex] < b[dataIndex]
			? -1
			: a[dataIndex] > b[dataIndex]
			? 1
			: 0;
		return result * reverse;
	});
};

export const filteratrion = (filters, data) => {
	return filters.reduce(
		(result, { dataIndex, value }) => {
			const transformed = value.map(
				(pattern) => new RegExp(`^${pattern.replace(/%/g, '.*')}$`, 'i')
			);
			return result.filter((row) =>
				transformed.some((regexp) => regexp.test(row[dataIndex]))
			);
		},
		[...data]
	);
};

export const columnFinder = (columns, dataIndex) => {
	return (
		(dataIndex &&
			(columns.find((col) => col.dataIndex === dataIndex) ||
				findColumnNested(columns, dataIndex))) ||
		{}
	);
};

const findColumnNested = (columns, dataIndex) => {
	return [...columns].reduce((result, column, index, arr) => {
		if (column.columns) {
			result = findColumnNested(column.columns, dataIndex);
		} else if (column.dataIndex === dataIndex) {
			result = column;
		}
		if (result) arr.splice(1); // stoping the iteration
		return result;
	}, null);
};

export const getRowSpan = (columns, number = 1) => {
	return columns.reduce((result, { columns: nestedColumns }) => {
		if (nestedColumns) {
			result = Math.max(result, getRowSpan(nestedColumns, number + 1));
		}
		return result;
	}, number);
};

export const getColSpan = (columns, number = 0) => {
	return columns.reduce((result, { columns: nestedColumns }) => {
		if (nestedColumns) {
			result = getColSpan(nestedColumns, result);
		} else {
			result++;
		}
		return result;
	}, number);
};

export const isDev = process.env.NODE_ENV === 'development';

export const is = {
	str: (a) => typeof a === 'string',
	fnc: (a) => typeof a === 'function',
};

export const css = (el, stylesheet) => {
	const style = el.style;
	Object.keys(stylesheet).forEach((key) => {
		style[key] = stylesheet[key];
	});
};

export const und = undefined;

export const dropdownContainer = document.createElement('div');

document.body.appendChild(dropdownContainer);
